import 'twin.macro';
import React from 'react';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import ButtonExternal from '@teetsh/app/src/components/Buttons/ExternalLink';
import { useTranslation } from 'react-i18next';

interface Props {
  toHome?: boolean;
  title?: string;
  children?: React.ReactNode;
  ctaLink?: string;
  ctaText?: string;
}

export function NotFoundPage(props: Props) {
  const { toHome, title, children, ctaLink, ctaText } = props;
  const { t } = useTranslation(['common']);
  return (
    <main tw="grid min-h-full place-items-center bg-white py-24 px-6 sm:py-32 lg:px-8">
      <div tw="text-center">
        <p tw="text-base font-semibold text-brand-intense">404</p>
        <h1 tw="mt-4 text-3xl font-bold tracking-tight text-neutral-intense sm:text-5xl">
          {title ? title : t('common:errorPage.pageNotFound')}
        </h1>
        <p tw="mt-6 text-base leading-7 text-neutral-quiet">
          {children || t('common:errorPage.pageNotFoundDescription')}
        </p>
        <div tw="mt-10 flex items-center justify-center gap-x-6">
          {toHome ? (
            <ButtonExternal
              target="_self"
              intent="primary"
              large
              href="https://teetsh.com/"
            >
              {t('common:errorPage.backToHome')}
            </ButtonExternal>
          ) : (
            <ButtonLink intent="primary" large to={ctaLink ? ctaLink : '/'}>
              {ctaText ? ctaText : t('common:errorPage.backToHome')}
            </ButtonLink>
          )}
        </div>
      </div>
    </main>
  );
}
